import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isBDD, hasShaDocumentUploaded } from '../utils/bdd';
import BddShaAlert from './BddShaAlert';

export function CustomReviewTopContent({ formData }) {
  const showBddShaAlert = isBDD(formData) && !hasShaDocumentUploaded(formData);

  return showBddShaAlert ? <BddShaAlert /> : null;
}

CustomReviewTopContent.propTypes = {
  formData: PropTypes.object,
};

const mapStateToProps = state => ({
  formData: state.form.data,
});

export default connect(mapStateToProps)(CustomReviewTopContent);
